import type { IMergeFieldType } from 'entities/Integrations'

const CHATBOT_FIELD_TYPES: IMergeFieldType[] = [
  'text',
  'url',
  'date',
  'datetime',
  'number',
  'single_select',
  'multi_select',
]

export const toChatbotFieldType = (type: string): IMergeFieldType =>
  CHATBOT_FIELD_TYPES.find((fieldType) => fieldType === type) ?? 'text'
